<!-- footerPage -->
<template>
  <div class="footerPage">
    <div class="innerBox">
      <div class="itemBox itemBox1">
        <div class="p1">
          <img src="../../static/images/common/电话.png" alt="" />
          <div class="label1 ft16cl54">Company landline</div>
          <div class="label2 ft20cl66">0755-29128850</div>
          <div class="label3 ft16cl54">Marketing and sales department</div>
          <div class="label4 ft20cl66">0755-29128802</div>
          <div class="label5 ft20cl66">19128390596 (Ms.He)</div>
          <div class="label6 ft20cl66">18681559268 (Ms.He)</div>
          <div class="label3 ft16cl54">New material innovation center</div>

          <div class="label5 ft20cl66">19128390686 (Mr.Zhang)</div>
          <div class="label6 ft20cl66">13809897866 (Mr.Zhang)</div>
        </div>
        <div class="p2">
          <img src="../../static/images/common/邮箱.png" alt="" />
          <div class="label1 ft16cl54">E-mail</div>
          <div class="label2 ft20cl66">aheli@levimelt.com</div>
          <div class="label3 ft20cl66">sales@levimelt.com</div>
        </div>
      </div>
      <div class="itemBox itemBox2">
        <div
          class="divBox"
          :class="'div' + (index + 1)"
          v-for="(item, index) in list"
          :key="item.value"
        >
          <div class="title">
            {{ item.name }}
          </div>
          <div class="title title2" v-if="item.name2">
            {{ item.name2 }}
          </div>
          <div
            class="tips"
            v-for="item2 in item.items"
            :key="item2.value"
            @click="tipsFunc(index, item2)"
          >
            {{ item2.name }}
          </div>
        </div>
      </div>
      <div class="itemBox itemBox3">
        <img src="../../static/images/common/公众号.jpg" alt="" />
        <div class="label">Wechat public account</div>
        <img src="../../static/images/common/联系.jpg" alt="" />
        <div class="label">Contact us</div>
      </div>
      <div class="bottom" @click="url">
        <div class="p1">
          COPYRIGHT 2023 WWW.LEVIMELT.COM. ALL RIGHTS RESERVED
        </div>
        <div class="p1">
          Shenzhen Summit New Materials Co., Ltd Guangdong ICP for 2023033620
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "footerPage",
  components: {},
  data() {
    return {
      list: [
        {
          name: "Melting equipment",
          items: [
            {
              name: "About equipment",
              value: "设备简介",
            },
            {
              name: "Equipment parts",
              value: "设备组成",
            },
            {
              name: "Leading technology",
              value: "领先技术",
            },
            {
              name: "Equipment application",
              value: "设备应用",
            },
            {
              name: "Equipment specification",
              value: "设备规格",
            },
            {
              name: "Client cases",
              value: "客户案例",
            },
          ],
        },
        {
          name: "Levitation melting",
          items: [
            {
              name: "Levitation melting",
              value: "悬浮冶金简介",
            },
            {
              name: "Technological advantage",
              value: "技术优势",
            },
            {
              name: "Application area",
              value: "应用领域",
            },
          ],
        },
        {
          name: "New",
          name2: "materials",
          items: [
            {
              name: "Material research production",
              value: "材料研制与生产",
            },
            {
              name: "Material product",
              value: "材料产品",
            },
            {
              name: "Client cases",
              value: "客户案例",
            },
          ],
        },
        {
          name: "Contact",
          name2: "us",
          items: [
            {
              name: "About us",
              value: "公司简介",
            },
            {
              name: "Milestones",
              value: "发展历程",
            },
            {
              name: "Honor qualification",
              value: "荣誉资质",
            },
          ],
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    tipsFunc(index, data) {
      this.$store.commit("savePageId", "#" + data.value);
      if (index == 0) {
        this.$store.commit("saveNavType", 22);
      } else if (index == 1) {
        this.$store.commit("saveNavType", 33);
      } else if (index == 2) {
        this.$store.commit("saveNavType", 44);
      } else if (index == 3) {
        this.$store.commit("saveNavType", 55);
      } else {
        this.$store.commit("saveNavType", 11);
      }
    },

    //跳转后可以复制
    url() {
      let textarea = document.createElement("textarea"); // 创建textarea
      textarea.readOnly = "readonly";
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      textarea.value = this.address; // 赋值给 textarea 值
      document.body.appendChild(textarea); // 插入进去
      textarea.select(); // 选择对象
      textarea.setSelectionRange(0, textarea.value.length);
      document.execCommand("Copy"); // 原生调用执行浏览器复制命令
      document.body.removeChild(textarea);
      textarea = null;
      window.location.href = "https://beian.miit.gov.cn/#/Integrated/index";
    },
  },
};
</script>

<style lang='less' scoped>
div {
  box-sizing: border-box;
}

.footerPage {
  width: 100%;
  height: 628px;
  color: #ffffff;
  background-color: #fbfbfb;
  color: #666666;
  font-size: 16px;

  .innerBox {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    padding-top: 60px;
    display: flex;
    flex-direction: row;
    position: relative;

    .ft20cl66 {
      font-size: 20px;
      color: #666666;
    }

    .ft16cl54 {
      color: #545454;
      font-size: 16px;
    }

    .itemBox1 {
      width: 308px;
      height: 464px;
      text-align: left;
      border-right: 1px solid #e4e4e4;
      .p1 {
        // height: 50px;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-left: 60px;
        position: relative;

        img {
          width: 48px;
          height: 48px;
          position: absolute;
          left: 0;
          top: 0;
        }

        .label1 {
          margin-top: -2px;
        }

        .label2 {
          margin-top: -2px;
          line-height: 40px;
        }

        .label3 {
          margin-top: 15px;
        }

        .label4,
        .label5,
        .label6 {
          line-height: 40px;
        }
      }

      .p2 {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding-left: 60px;
        position: relative;
        margin-top: 40px;

        img {
          width: 48px;
          height: 48px;
          position: absolute;
          left: 0;
          top: 0;
        }

        .label2,
        .label3 {
          line-height: 40px;
        }
      }
    }

    .itemBox2 {
      text-align: left;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      padding-left: 35px;

      .divBox {
        width: 130px;
        height: 100%;

        .title {
          font-size: 18px;
          line-height: 24px;
          color: #333333;
          margin-bottom: 21px;
        }
        .title2 {
          margin-top: -21px;
        }
        .tips {
          color: #545454;
          font-size: 16px;
          line-height: 24px;
          cursor: pointer;
          margin-bottom: 13px;
        }
        .tips:hover {
          color: #333333;
        }
      }
    }

    .itemBox3 {
      width: 160px;
      height: 100%;

      img {
        width: 160px;
        height: 160px;
      }

      .label {
        margin-bottom: 85px;
        font-size: 16px;
        letter-spacing: 2px;
        color: #545454;
      }
    }

    .bottom {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
      padding-bottom: 10px;

      .p1 {
        font-size: 14px;
        color: #545454;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footerPageEn.vue